import { Button } from "@/components/ui/button";
import { Section, SectionHeader } from "@/components/ui/section";
import { useTranslation } from "@/hooks/useTranslation";
import { PromptOwnerType } from "@shaarp/common";
import { memo } from "react";
import { LuPlus } from "react-icons/lu";

type EmptyPromptSectionProps = {
  ownerType: PromptOwnerType;
  teamName?: string;
  onCreateClick: () => void;
};

function EmptyPromptSection({
  ownerType,
  teamName,
  onCreateClick,
}: EmptyPromptSectionProps) {
  const { t } = useTranslation();

  const isPersonal = ownerType === "user";
  const sectionId = isPersonal ? "user" : "team";
  const title = isPersonal
    ? t("prompt.library.tabs.personal")
    : t("prompt.library.tabs.team");
  const description = isPersonal
    ? t("prompt.library.custom.descriptionPersonal")
    : t("prompt.library.custom.descriptionTeam", {
        teamName: teamName ?? t("prompt.library.tabs.team"),
      });
  const emptyTitle = isPersonal
    ? t("prompt.library.emptyPersonal.title")
    : t("prompt.library.emptyTeam.title");
  const emptyDescription = isPersonal
    ? t("prompt.library.emptyPersonal.description")
    : t("prompt.library.emptyTeam.description");
  const ctaLabel = isPersonal
    ? t("prompt.library.emptyPersonal.cta")
    : t("prompt.library.emptyTeam.cta");

  return (
    <Section id={sectionId}>
      <SectionHeader title={title} description={description} />
      <div className="flex flex-col items-center justify-center py-8 border border-dashed rounded-lg bg-muted/20 border-muted-foreground/20">
        <p className="mb-1 text-sm font-medium text-foreground">{emptyTitle}</p>
        <p className="mb-4 text-sm text-muted-foreground">{emptyDescription}</p>
        <Button size="sm" onClick={onCreateClick} type="submit">
          <LuPlus className="mr-2 size-4" />
          {ctaLabel}
        </Button>
      </div>
    </Section>
  );
}

export default memo(EmptyPromptSection);
